<template>
  <div
    class="!z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
  >
    <div
      class="!z-999 relative flex justify-center items-center bg-white p-5 lg:p-8 w-[90%] lg:w-[380px] xl:w-[400px] 2xl:w-[500px] rounded-xl"
    >
      <div class="w-full flex flex-col gap-5">
        <div class="capitalize text-3xl font-semibold text-center">
          under maintenance
        </div>
        <div class="w-full flex items-center justify-center gap-4">
          <button
            @click="refreshPage"
            type="button"
            class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-md"
          >
            Refresh
          </button>
          <button
            @click="closeForm"
            type="button"
            class="text-xs font-bold text-[#0085db] px-5 py-1.5 border border-[#0085db] rounded-md hidden"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    closeForm() {
      this.$emit("close");
    },
    refreshPage() {
      location.reload();
    },
  },
};
</script>

<style>
</style>